let timer;
const createMap = ()=>{
    const dom = document.querySelector('#one_map');
    timer = setTimeout(() => {
        if(!Object.prototype.hasOwnProperty.call(window, 'AMap')){
            clearTimeout(timer)
            createMap();
        }else{
            var map = new window.AMap.Map(dom, {
                zoom:10,//级别
                center: [116.397428, 39.90923],//中心点坐标
                viewMode:'3D'//使用3D视图
            });
            console.log(map,dom)
        }
   }, 100);
} 

export default {
    createMap
}


// WEBPACK FOOTER //
// ./src/package/one_map_zmap.js